import { Text } from '@innovationdepartment/proxima-ui';
import { formatCurrency } from 'utils';
import type { BrandProductCellRendererComponentProps } from '../types';

const BrandProductsTotalRevenue = (
  props: BrandProductCellRendererComponentProps<'totalRevenueUsd'>
) => {
  const { value } = props;

  return (
    <Text color="green40" variant="table1">
      {formatCurrency(+value)}
    </Text>
  );
};

export default BrandProductsTotalRevenue;
